import React from "react";

export default ({ className, value, style }) => {
  return (
    <div className={className} style={style}>
      <span className="drop">{value}</span>
    </div>
  );
};
